import { useParams } from 'react-router-dom'
import { parseYear } from '../lib/filterUrl.js'

// #338: the year segment of the current route, or null when there isn't one.
//
// Cards use it so their permalinks stay inside the year being browsed. It reads
// the route rather than taking a prop because a card renders in four places —
// the calendar, the map popup, a conference card, an event page — and threading
// the year through all of them would be four chances to forget.
export default function useCurrentYear() {
  const { year } = useParams()
  return parseYear(year)
}
